import React, {Fragment} from "react";

import './FormInputCheckbox.scss' ;
import FormToggle from "root/ReactHookForm/ui/FormToggle";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents/SmartErrorDiv";

export const labelPositions = {
    TOP: 1,
    RIGHT: 2,
}

const FormInputToggle = ( { control, formErrors, readOnly, label, sectionName, name, style, className, labelPosition } ) =>
{
    const classText = className === undefined ? "form-field" : '' ;
    const styleObj = style === undefined ? {} : style ;

    const labelTop = labelPosition === labelPositions.TOP || labelPosition === undefined ;

    const rightLabelStyle = { verticalAlign: 'super', paddingLeft: '30px', display: 'inline', position: 'relative', top: '-2px' } ;

    return (
        <div className={classText} style={styleObj}>
            { labelTop && <label className='form-label'>{label}</label> }
            <div style={{marginTop: '10px'}}>
                <FormToggle readOnly={readOnly} control={control} name={sectionName + '.' + name}/>
                { !labelTop && <div style={rightLabelStyle}><label className='form-label' style={{display: 'inline'}}>{label}</label></div> }
            </div>
            <SmartErrorDiv sectionName={sectionName} name={name} formErrors={formErrors} />
        </div>
    )
}

export { FormInputToggle };